import { render, staticRenderFns } from "./ProcessDefinition.vue?vue&type=template&id=0caa380c&"
import script from "./ProcessDefinition.vue?vue&type=script&lang=js&"
export * from "./ProcessDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports